import request from './request'

// 获取简历列表
export function getResumeList() {
  return request({
    url: '/api/resume/list',
    method: 'get',
  })
}

// 获取简历分类
export function getResumeCategory(params) {
  return request({
    url: '/api/resume/category',
    method: 'get',
    params
  })
}

// 添加简历分类
export function addResumeCategory(data) {
  return request({
    url: '/api/resume/add/category',
    method: 'post',
    data
  })
}
// 在原有简历基础上新增简历
export function addResumeToBaseResume(data) {
  return request({
    url: '/api/resume/add/newResume',
    method: 'post',
    data
  })
}

// 添加简历初始化
export function addResume(data) {
  return request({
    url: '/api/resume/init',
    method: 'post',
    data
  })
}

// 简历基本信息添加
export function addResumeBasicInfo(data) {
  return request({
    url: '/api/resume/add/basicInfo',
    method: 'post',
    data
  })
}

// 教育经历添加
export function addResumeEducationExperience(data) {
  return request({
    url: '/api/resume/add/educationExperience',
    method: 'post',
    data
  })
}

// 社团组织经历添加
export function addResumeOrganizationExperience(data) {
  return request({
    url: '/api/resume/add/organizationExperience',
    method: 'post',
    data
  })
}

// 实习经历添加
export function addResumeInternshipExperience(data) {
  return request({
    url: '/api/resume/add/internshipExperience',
    method: 'post',
    data
  })
}

// 学术经历添加
export function addResumeAcademicExperience(data) {
  return request({
    url: '/api/resume/add/academicExperience',
    method: 'post',
    data
  })
}

// 获奖经历添加
export function addResumeAwardExperience(data) {
  return request({
    url: '/api/resume/add/awardExperience',
    method: 'post',
    data
  })
}

// 技能语言添加
export function addResumeSkillLanguage(data) {
  return request({
    url: '/api/resume/add/skillLanguage',
    method: 'post',
    data
  })
}

// 简历删除
export function deleteResume(params) {
  return request({
    url: '/api/resume/delete',
    method: 'DELETE',
    params
  })
}

// 更新分类
export function updateResumeCategory(data) {
  return request({
    url: '/api/resume/update/category',
    method: 'post',
    data
  })
}

// 删除分类
export function deleteResumeCategory(params) {
  return request({
    url: '/api/resume/delete/category',
    method: 'DELETE',
    params
  })
}

// 保存简历到简历库
/*
保存简历到简历库
  入参简历名称（resume_name），
  简历大小（resume_size,单位kb，需要转成m），
  简历地址（resume_url），
  上传时间（非必填，默认当前时间）
*/
export function saveResume(data) {
  return request({
    url: '/api/resume/save',
    method: 'post',
    data,
  })
}
// 删除简历库中的简历
export function deleteResumes(id) {
  return request({
    url: '/api/resume/' + id,
    method: 'delete',
  })
}
// 根据ID获取简历详情
export function getResumeById(id) {
  return request({
    url: '/api/resume/' + id,
    method: 'get',
  })
}
// 更新简历基本信息